// dataTables.js

import { getLoadingElement } from './loadingIndicator.js';

/**
 * Updates all date tables.
 */
const updateDateTables = (date) => {
  document.querySelectorAll('[data-date-table]').forEach(element => {
    const url = element.getAttribute('data-date-table');

    try {
      const loadingElement = getLoadingElement(element.parentElement);

      fetch(url + '?date=' + date)
        .then(response => {
          if (!response.ok) {
            throw new Error('HTTP error ' + response.status);
          }
          return response.json();
        })
        .then(json => {
          element.querySelectorAll('[data-field]').forEach(valueElement => {
            const value = json[valueElement.getAttribute('data-field')] ?? '-';

            if (valueElement.tagName === 'PROGRESS') {
              valueElement.value = Number(value) || 0;
            } else {
              valueElement.innerText = value;
            }
          });
        })
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          loadingElement?.classList.remove('show');
        });
    } catch (e) {
      console.warn('Date table failure.');
      console.error(e);
    }
  });
};

document.addEventListener('dateChange', (e) => {
  updateDateTables(e.detail.date);
});
